import React, { useEffect, useState } from "react";
import { api } from "../../api/client";
import ConfirmModal from "../../components/ConfirmModal";

const JOURS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export default function BarAdmin() {
  const [horaires, setHoraires] = useState([]);
  const [fermetures, setFermetures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [nouvelleFermeture, setNouvelleFermeture] = useState({ date_debut: "", date_fin: "", motif: "" });
  const [confirmDelFermeture, setConfirmDelFermeture] = useState(null);

  const reload = () => {
    setLoading(true);
    api.get("/bar/horaires")
      .then((r) => {
        setHoraires(r.horaires || []);
        setFermetures(r.fermetures || []);
      })
      .finally(() => setLoading(false));
  };
  useEffect(reload, []);

  const updateHoraire = (jour, field, value) => {
    setHoraires(horaires.map((h) =>
      h.jour === jour ? { ...h, [field]: value } : h
    ));
  };

  const saveHoraires = async () => {
    setSaving(true);
    setMsg("");
    try {
      await api.put("/bar/admin/horaires", { horaires });
      setMsg("Horaires enregistrés ✓");
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg("Erreur : " + (e.message || e));
    } finally {
      setSaving(false);
    }
  };

  const addFermeture = async () => {
    if (!nouvelleFermeture.date_debut || !nouvelleFermeture.date_fin) {
      alert("Renseignez les dates");
      return;
    }
    try {
      await api.post("/bar/admin/fermetures", nouvelleFermeture);
      setNouvelleFermeture({ date_debut: "", date_fin: "", motif: "" });
      reload();
    } catch (e) {
      alert("Erreur : " + (e.message || e));
    }
  };

  const removeFermeture = async () => {
    if (!confirmDelFermeture) return;
    await api.del(`/bar/admin/fermetures/${confirmDelFermeture.id}`);
    setConfirmDelFermeture(null);
    reload();
  };

  if (loading) return <p className="muted">Chargement…</p>;

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Horaires hebdomadaires</h3>
      <p className="muted" style={{ fontSize: "0.9em" }}>
        Décochez « Fermé » pour activer les horaires d'un jour. Par défaut :
        vendredi et samedi 18h-22h.
      </p>
      <table className="biblio-horaires-edit">
        <thead>
          <tr>
            <th>Jour</th>
            <th>Fermé</th>
            <th>Heure d'ouverture</th>
            <th>Heure de fermeture</th>
          </tr>
        </thead>
        <tbody>
          {horaires.map((h) => (
            <tr key={h.jour}>
              <td><strong>{JOURS[h.jour]}</strong></td>
              <td>
                <input type="checkbox" checked={!!h.ferme}
                       onChange={(e) => updateHoraire(h.jour, "ferme", e.target.checked ? 1 : 0)} />
              </td>
              <td>
                <input type="time" value={h.heure_ouverture}
                       disabled={!!h.ferme}
                       onChange={(e) => updateHoraire(h.jour, "heure_ouverture", e.target.value)} />
              </td>
              <td>
                <input type="time" value={h.heure_fermeture}
                       disabled={!!h.ferme}
                       onChange={(e) => updateHoraire(h.jour, "heure_fermeture", e.target.value)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: "flex", gap: "1rem", alignItems: "center", marginTop: "1rem" }}>
        <button className="btn-primary" onClick={saveHoraires} disabled={saving}>
          {saving ? "Enregistrement..." : "💾 Enregistrer les horaires"}
        </button>
        {msg && <span className="muted">{msg}</span>}
      </div>

      <h3 style={{ marginTop: "2rem" }}>Fermetures exceptionnelles</h3>
      <p className="muted" style={{ fontSize: "0.9em" }}>
        Ces fermetures sont prioritaires sur les horaires hebdo et seront
        exclues du calendrier communal.
      </p>
      <div className="biblio-fermeture-form">
        <label>
          Du :
          <input type="date" value={nouvelleFermeture.date_debut}
                 onChange={(e) => setNouvelleFermeture({...nouvelleFermeture, date_debut: e.target.value})} />
        </label>
        <label>
          Au :
          <input type="date" value={nouvelleFermeture.date_fin}
                 onChange={(e) => setNouvelleFermeture({...nouvelleFermeture, date_fin: e.target.value})} />
        </label>
        <label style={{ flex: 1 }}>
          Motif (facultatif) :
          <input type="text" value={nouvelleFermeture.motif}
                 placeholder="Congés, événement..."
                 onChange={(e) => setNouvelleFermeture({...nouvelleFermeture, motif: e.target.value})} />
        </label>
        <button className="btn-primary" onClick={addFermeture}>+ Ajouter</button>
      </div>

      {fermetures.length === 0 ? (
        <p className="muted">Aucune fermeture exceptionnelle prévue.</p>
      ) : (
        <table className="biblio-admin-table">
          <thead>
            <tr><th>Du</th><th>Au</th><th>Motif</th><th></th></tr>
          </thead>
          <tbody>
            {fermetures.map((f) => (
              <tr key={f.id}>
                <td>{f.date_debut}</td>
                <td>{f.date_fin}</td>
                <td>{f.motif || <span className="muted">—</span>}</td>
                <td>
                  <button className="link-btn danger" onClick={() => setConfirmDelFermeture(f)}>
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {confirmDelFermeture && (
        <ConfirmModal
          titre="Supprimer cette fermeture"
          message={`Supprimer la fermeture du ${confirmDelFermeture.date_debut} au ${confirmDelFermeture.date_fin} ?`}
          confirmLabel="Supprimer"
          danger
          onConfirm={removeFermeture}
          onCancel={() => setConfirmDelFermeture(null)}
        />
      )}
    </div>
  );
}
